import { render, staticRenderFns } from "./AmendedPlanHistory.vue?vue&type=template&id=8a1604f8&scoped=true"
import script from "./AmendedPlanHistory.vue?vue&type=script&lang=js"
export * from "./AmendedPlanHistory.vue?vue&type=script&lang=js"
import style0 from "./AmendedPlanHistory.vue?vue&type=style&index=0&id=8a1604f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1604f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a1604f8')) {
      api.createRecord('8a1604f8', component.options)
    } else {
      api.reload('8a1604f8', component.options)
    }
    module.hot.accept("./AmendedPlanHistory.vue?vue&type=template&id=8a1604f8&scoped=true", function () {
      api.rerender('8a1604f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/AmendedPlanHistory.vue"
export default component.exports